
import "../styles/footer.css"

export default function Footer(){


    return(
        <>
          <div className="footerBack2">
            <p>© 2022 MENU. Todos os direitos reservados.</p>
        </div>
        </>
    )
}